import React from "react";
import { Lock, Eye, Heart } from "lucide-react";
import { privacyImage } from "../mock";

const Privacy = () => {
  return (
    <section className="relative py-20 lg:py-28 bg-[#faf3eb] overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
        <div className="order-2 lg:order-1">
          <div className="flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-[#daae9c]">
            <span className="w-6 h-px bg-sterling-dark" />
            Discretion & Respect
          </div>
          <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl text-ink mt-4 leading-[1.05] text-balance">
            Privacy is part of the{" "}
            <span className="italic text-[#daae9c]">service.</span>
          </h2>
          <p className="mt-6 text-ink/70 leading-relaxed">
            Inviting someone into your home requires trust. Every service is
            delivered with the highest level of professionalism, discretion and
            respect for your privacy. Our team works quietly and carefully
            within your space.
          </p>
          <p className="mt-4 text-ink/70 leading-relaxed">
            For this reason, we do not share before-and-after images of our
            clients’ homes. The experience of a beautifully cleaned home
            should remain entirely yours.
          </p>

          <div className="mt-8 grid sm:grid-cols-3 gap-4">
            {[
              { icon: Lock, title: "Confidential", desc: "Always discreet" },
              { icon: Eye, title: "Respectful", desc: "Quietly thorough" },
              { icon: Heart, title: "Caring", desc: "Treated like our own" },
            ].map((p, i) => {
              const Icon = p.icon;
              return (
                <div
                  key={i}
                  className="p-5 rounded-xl bg-white border border-[#ead8c9]"
                >
                  <Icon size={18} className="text-[#daae9c]" />
                  <div className="mt-3 font-serif-display text-lg text-ink">
                    {p.title}
                  </div>
                  <div className="text-xs text-ink/60 mt-1">{p.desc}</div>
                </div>
              );
            })}
          </div>
        </div>

        <div className="order-1 lg:order-2 relative">
          <div className="absolute -inset-4 bg-sterling/20 rounded-3xl -z-10" />
          <img
            src={privacyImage}
            alt="Elegant interior"
            className="w-full h-[420px] lg:h-[540px] object-cover rounded-2xl"
          />
        </div>
      </div>
    </section>
  );
};

export default Privacy;
